import React from 'react';
import MeetingFilteredList from './MeetingFilteredList';

const TodayMeetings = () => {
  return (
    <MeetingFilteredList 
      title="Bugünkü Görüşmeler"
      filterType="today"
    />
  );
};

export default TodayMeetings;
